<app-question-form
  title="Ask me a question"
  [initialMessage]="(lastAskedQuestionsService.multiQuestionResponse$ | async)?.message"
  [isFetching]="isFetching"
  [response]="(lastAskedQuestionsService.multiQuestionResponse$ | async)?.response"
  [feedbackValue]="feedbackValue"
  (onSubmit)="handleMessageSubmit($event)"
  (onFeedback)="handleFeedbackSubmit($event)"
></app-question-form>
